import { array, object, string } from 'yup'

const MIN_EMAILS_LABEL = 'Informe pelo menos um email'

export const ExportVoucherReportSchema = object().shape({
  wantedFields: array().min(1, 'Por favor, selecione ao menos uma coluna para exportação'),
  format: string().required('Selecione o formato da exportação'),
  emails: array().of(string().email('Email inválido')).min(1, MIN_EMAILS_LABEL).required(MIN_EMAILS_LABEL)
})
